export const roles = {
    'front-desk': ['add-patient', 'upload-referral', 'create-appointment', 'change-appointment'],
    records: ['add-patient', 'edit-patient', 'assign-ipno', 'edit-diagnoses', 'code-visits'],
    cashier: ['receive-payment', 'edit-patient'],
    triage: ['take-vitals', 'view-notes'],
    consultation: ['see-patient', 'fill-consultation'],
    documents: ["access-hosted-documents"],
    'stock-take': ['create-stock-take-tally', 'tally-stock-take'],
    lab: [],
    radiography: [],
    sonography: [],
    nursing: [],
    physiotherapy: [],
    trauma: [],
    dental: [],
    'dental-lab': [],
    'dental-xray': [],
    theatre: [],
    marketing: ['send-sms'],
    inpatient: ['admit-patient', 'view-admissions', ],
    'human-resources': [],
    pharmacy: [],
    store: ['create-stores', 'edit-items', 'view-available-batches'],
    procurement: [],
    'credit-control': [],
    'credit-patient-docs': [],
    reports: [],
    sales: [],
    accounts: [],
    admin: ['patient-operations', 'reports', 'stores', 'documents', 'sale-items', 'admissions', 'users', 'insurance', 'roles', 'documents', 'parameters'],
    // Eye Clinic (optical) - granular permissions for the outreach screening build. Existing
    // Eye Clinic Staff roles keep '*' and are unaffected; the CHW role is seeded with only
    // outreach-screening. See docs/planning/EYE_CLINIC_OUTREACH_SCOPE.md §3.2.
    optical: ['outreach-screening', 'outreach-manage', 'eye-clinic'],
}

export const stores = [
    'handle-requests', 
    'stock-take', 
    'view-request-history',
    'view-history', 
    'view-movement', 
    'restock-items', 
    'move-stock', 
    'modify-quantity', 
    'record-returns',
    'record-spoilage-damage', 
    'issue-to-self'
]